<template>
  <a-config-provider :locale="zhCN">
    <a-drawer title="选择服务分类" width="900" :visible="visible" :destroy-on-close="false" @close="handleCancel">
      <!-- 搜索 -->
      <a-form layout="inline" >
        <a-form-item label="分类名称">
          <a-input v-model="query.categoryName" allow-clear placeholder="请输入" @keyup.enter="getList" />
        </a-form-item>
       
        <a-form-item>
          <a-button type="primary" @click="getList">查询</a-button>
          <a-button style="margin-left: 8px" @click="resetQuery">重置</a-button>
        </a-form-item>
      </a-form>

      <!-- 一层表格 -->
      <a-table
        row-key="id"
        :loading="loading"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :row-selection="{
          type: 'radio',
          selectedRowKeys: selectedKeys,
          onChange: onSelectChange,
        }"
      >
        <span slot="status" slot-scope="text">
          <a-tag v-if="text === 1" color="green">启用</a-tag>
          <a-tag v-else color="red">禁用</a-tag>
        </span>
        <span slot="parentId">
          <a-tag color="green">一层</a-tag>
        </span>
        <div slot="pic" slot-scope="text, record">
          <img
            :src="$url + record.pic"
            style="width: 40px; height: 40px; object-fit: cover"
            @error="(e) => (e.target.src = errorImg)"
          />
        </div>

         <div slot="icon" slot-scope="text, record">
          <img
            :src="$url + record.icon"
            style="width: 40px; height: 40px; object-fit: cover"
            @error="(e) => (e.target.src = errorImg)"
          />
        </div>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        size="small"
        style="margin-top: 16px; text-align: right"
        show-size-changer
        :current="query.pageNum"
        :page-size="query.pageSize"
        :total="total"
        :show-total="(t) => `共 ${t} 条`"
        @change="changePage"
        @showSizeChange="changeSize"
      />

      <!-- 底部 -->
      <div class="drawer-footer">
        <a-button @click="handleCancel">取消</a-button>
        <a-button type="primary" :disabled="!selectedKeys.length" @click="handleOk">确定</a-button>
      </div>
    </a-drawer>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import { fetchList } from '@/api/maintenance/service/index.js'

const errorImg = require('/src/assets/images/defaultImg.png')

export default {
  name: 'ServiceCategoryPicker',
  data() {
    return {
      zhCN,
      errorImg,
      visible: false,
      loading: false,
      list: [],
      total: 0,
      selectedKeys: [],
      selectedRow: null,
      query: {
        pageNum: 1,
        pageSize: 10,
        categoryName: '',
        status: 1,
        parentId: 0,
      },
      columns: [
       { title: '分类名称', dataIndex: 'categoryName', align: 'center' },
        { title: '分类层级', dataIndex: 'parentId', scopedSlots: { customRender: 'parentId' }, align: 'center' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center' },
        { title: '类目图片', dataIndex: 'pic', scopedSlots: { customRender: 'pic' }, align: 'center' },
        { title: '类目图标', dataIndex: 'icon', scopedSlots: { customRender: 'icon' }, align: 'center' },
        // { title: '排序', dataIndex: 'sort', align: 'center' },
        // { title: '备注', dataIndex: 'remark', ellipsis: true, align: 'center' },
        // { title: '创建时间', dataIndex: 'createTime', ellipsis: true, align: 'center' },
      ],
      resolve: null,
    }
  },
  methods: {
    open(selectedId = '') {
      this.visible = true
      this.selectedKeys = selectedId ? [selectedId] : []
      this.selectedRow = null
      this.getList()
      return new Promise((resolve) => {
        this.resolve = resolve
      })
    },
    handleCancel() {
      this.visible = false
      this.resolve(null)
    },
    handleOk() {
      this.visible = false
      this.resolve(this.selectedRow)
    },
    getList() {
      this.loading = true
      fetchList(this.query).then((res) => {
        this.list = res.data.records
        this.total = res.data.total
        this.loading = false
        if (this.selectedKeys.length) {
          this.selectedRow = this.list.find((i) => i.id === this.selectedKeys[0]) || null
        }
      })
    },
    resetQuery() {
      this.query = { ...this.query, pageNum: 1, categoryName: '', status: 1 }
      this.getList()
    },
    changePage(p) {
      this.query.pageNum = p
      this.getList()
    },
    changeSize(cur, size) {
      this.query.pageSize = size
      this.getList()
    },
    onSelectChange(keys, rows) {
      this.selectedKeys = keys
      this.selectedRow = rows[0] || null
    },
  },
}
</script>

<style scoped>
.drawer-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #f0f0f0;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
}
</style>
